module.exports = __webpack_public_path__ + "img/stability@2x.8db48c80.png";